import React, { useReducer } from 'react'
import LinkedInContext from './linkedinContext'
import LinkedInReducer from './linkedinReducer'
import { apiCall } from '../../../common/api'
import { response } from '../../common'

import { GET_LINKED_USER_DETAILS, CLEAR_RESPONSE, RESPONSE_STATUS } from './linkedinType'

const LinkedInState = (props) => {
    const initialState = {
        responseStatus: null,
        linkedUserDetails: {},
    }

    const [state, dispatch] = useReducer(LinkedInReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getLinkedUserDetails = async (formData, fromVariable) => {
        const from = 'getLinkedUserDetails'
        try {
            const [res] = await Promise.all([
                apiCall('post', from, formData, '', 'third_party/linkedIn'),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_LINKED_USER_DETAILS,
                    payload: {
                        records: res.data.data.responseData.records.data
                            ? res.data.data.responseData.records.data
                            : [],
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }
    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })
    return (
        <LinkedInContext.Provider
            value={{
                responseStatus: state.responseStatus,
                linkedUserDetails: state.linkedUserDetails,
                clearResponse,
                getLinkedUserDetails,
            }}
        >
            {props.children}
        </LinkedInContext.Provider>
    )
}

export default LinkedInState
